import Flickity from 'flickity'
import deBounce from 'lodash.debounce'

$(function () {
    function setUniformSlideHeight(container) {
        var tallestHeight = 0;
        $('.slide', container).css('height', 'auto');
        $('.slide', container).each(function () {
            if ($(this).height() > tallestHeight)
                tallestHeight = $(this).height();
        });
        $('.slide', container).height(tallestHeight);
    }

    let flktyInstances = [];

    function initializeFlickity(container) {
        if (!$(container).hasClass('flickity-enabled')) {
            let flkty = new Flickity(container, {
                wrapAround: true,
                pageDots: true,
                cellAlign: "center",
                accessibility: false,
                draggable: false
            });

            flkty.on("select", function (index) {
                const parentCarousel = $(this.element).closest('.testimonials-carousel');
                $(".testimonial-background.active", parentCarousel).removeClass("active");
                $('.testimonial-background[data-slide="' + index + '"]', parentCarousel).addClass("active");
            });

            flktyInstances.push(flkty);
        }
    }

    $(".testimonials-carousel .review-slider").each(function () {
        if ($(this).find(".slide").length > 1) {
            setUniformSlideHeight(this);
            initializeFlickity(this);
            $(window).on('load resize', deBounce(function () {
                let flktyInstance = flktyInstances.find(instance => instance.element === this);

                if (flktyInstance) {
                    setUniformSlideHeight(this);
                    flktyInstance.resize();
                }
                //initializeFlickity(this);
            }.bind(this), 100));
        }
    });
});